/**
 * Helpers de cor compartilhados pelas telas que derivam fundos/realces
 * a partir da cor cadastrada na categoria (hex opaco vindo do cadastro).
 */

export const hexToRgb = (hex) => {
    let value = hex.replace("#", "");
    if (value.length === 3) value = value.split("").map((c) => c + c).join("");
    return [
        parseInt(value.slice(0, 2), 16),
        parseInt(value.slice(2, 4), 16),
        parseInt(value.slice(4, 6), 16),
    ];
};

// Fundo suave derivado da cor da categoria
export const hexToRgba = (hex, alpha) => {
    const [red, green, blue] = hexToRgb(hex);
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

// Texto branco ou escuro conforme a luminância, para cores claras continuarem legíveis
export const contrastText = (hex) => {
    const [red, green, blue] = hexToRgb(hex);
    return (0.299 * red + 0.587 * green + 0.114 * blue) / 255 > 0.6
        ? "#1F2937"
        : "#FFFFFF";
};
